// Vue组合式函数
import { useI18n } from 'vue-i18n';
export const useWindowsOpen = (url: string, target = '_blank') => {
  return window.open(url, target);
};

export const useT: any = (key: string) => {
  const { t } = useI18n();
  return t(key);
};
